import { Alert, Box, Card, CardContent, Skeleton, Stack } from '@mui/material'
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom'
import { FC, useMemo } from 'react'
import { WaitingCampaignCell } from './WaitingCampaignCell'
import { SectionCardContainer } from '~/components/common/SectionCardContainer'
import { CampaignOrderField, CampaignStatus, useWaitingCampaignListQuery } from '~/generated/graphql'

const WaitingCampaignLoading: FC = () => {
  return (
    <Stack gap={1}>
      <Card>
        <CardContent sx={{ display: 'flex', overflowX: 'hidden' }}>
          <Stack direction="row" gap={3}>
            {new Array(5).fill('').map((_, i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                width="128px"
                height="150px"
                sx={{
                  borderRadius: '5px',
                  flexShrink: 0,
                  mt: '10px',
                  mb: '20px',
                }}
              />
            ))}
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  )
}

export const waitingCampaignInput = {
  input: {
    status: [CampaignStatus.ApprovalRequest, CampaignStatus.RevisionRequired],
    orderBy: {
      direction: 'DESC',
      field: CampaignOrderField.Id,
    },
  },
} as const
export const WaitingCampaignList: FC = () => {
  const { data, loading } = useWaitingCampaignListQuery({
    variables: waitingCampaignInput,
  })

  const waitingCampaigns = useMemo(() => {
    if (loading) return <WaitingCampaignLoading />

    const hasCampaigns = !!data?.viewer.campaigns.length
    if (!hasCampaigns) {
      return <Alert severity="info">審査待ちのキャンペーンはありません。</Alert>
    }

    return (
      <Card>
        <CardContent sx={{ overflowX: 'scroll', scrollbarGutter: 'stable' }}>
          <Stack direction="row" gap={3}>
            {data.viewer.campaigns.map((x) => (
              <WaitingCampaignCell key={x.id} campaign={x} />
            ))}
            {/* 最終要素の右パディング用 */}
            <Box pr={1} />
          </Stack>
        </CardContent>
      </Card>
    )
  }, [loading, data])

  return (
    <SectionCardContainer title="公開前キャンペーン" icon={<HourglassBottomIcon sx={{ fontSize: '20px' }} />}>
      {waitingCampaigns}
    </SectionCardContainer>
  )
}
